import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Skills = () => {
  const { t } = useLanguage();

  return (
    <section id="service" className="py-20 px-5 bg-bg-black-900">
      <div className="container mx-auto max-w-6xl">
        <div className="section-title mb-16">
          <h2 className="text-4xl font-bold relative inline-block pb-3">{t.skills.title}</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.skills.items.map((item, idx) => (
            <div key={idx} className="service-item-inner bg-bg-black-100 border border-bg-black-50 rounded-lg p-8 text-center transition-all duration-300 ease-in-out hover:shadow-[0_0_20px_rgba(48,46,77,0.15)]">
              <div className="icon h-16 w-16 rounded-full mx-auto mb-8 flex items-center justify-center transition-all duration-300 ease-in-out">
                <i className={`fa ${item.icon} text-4xl text-skin-color transition-all duration-300 ease-in-out`}></i>
              </div>
              <h4 className="text-lg font-bold mb-4 text-text-black-900 capitalize">{item.label}</h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
